import PageBanner from "app/components/ui/PageBanner"
import SiteGrid from "app/components/ui/SiteGrid"
import HelmetTitle from "app/meta/HelmetTitle"
import React, { useEffect, useRef, useState } from 'react'
import './styles/AppointmentPage.css'
import AppCalendar from "app/components/ui/AppCalendar"
import { monthsEvents } from "app/data/appointmentsData"
import { convertClassicDate } from "app/utils/dateUtils"
import AppButton from "app/components/ui/AppButton"
import { AppInput } from "app/components/ui/AppInputs"
import { dateChangeService } from "app/services/calendarServices"
import { isEmptyText, validateEmail } from "app/utils/generalUtils"
import { useTeamMember } from "app/hooks/teamHooks"

export default function AppointmentPage() {

  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [calendarRangeStartDate, setCalendarRangeStartDate] = useState(null)
  const [calendarRangeEndDate, setCalendarRangeEndDate] = useState(null)
  const [customCalendarViewTitle, setCustomCalendarViewTitle] = useState('')
  const [activeDate, setActiveDate] = useState(null)
  const [activeTime, setActiveTime] = useState(null)
  const calendarRef = useRef(null)
  const calendarAPI = calendarRef?.current?.getApi()
  const selectedTimeslot = monthsEvents?.find((month) => month.monthNumber === activeDate?.getMonth() + 1)
    ?.events.find((event) => event.date.getTime() === activeDate?.getTime())
  const availableDoctorID = selectedTimeslot?.availabilities?.find((availability) => availability.time === activeTime)?.doctorID
  const doctor = useTeamMember(availableDoctorID)
  const hasAvailabilities = selectedTimeslot?.availabilities?.length > 0

  const allowBooking = !isEmptyText(name)
    && validateEmail(email)
    && activeDate
    && activeTime


  const handleTimeSlotClick = (time) => {
    setActiveTime(time)
  }

  const slotsRender = monthsEvents
    ?.filter((month) => month.monthNumber === activeDate?.getMonth() + 1)
    .map((month, index) => {
      return month.events.map((event, index) => {
        if (event.date.getTime() === activeDate?.getTime()) {
          return event.availabilities.map((availability, index) => {
            return <TimeSlot
              key={`${event.date.toString()}-${availability.time}`}
              time={availability.time}
              isBooked={availability.booked}
              isActive={activeTime === availability.time}
              onClick={handleTimeSlotClick}
            />
          })
        }
        return null
      })
    })

  const handleDateClick = (e) => {
    setActiveDate(e.date)
    setActiveTime(null)
  }

  const customDayClassNames = (date) => {
    if (date.date.getTime() === activeDate?.getTime()) {
      return 'fc-day-active'
    }
    return ''
  }

  const goToToday = () => {
    dateChangeService(
      'today',
      calendarAPI,
      setCustomCalendarViewTitle,
      setCalendarRangeStartDate,
      setCalendarRangeEndDate
    )
    setActiveDate(new Date(new Date().setHours(0, 0, 0, 0)))
    setActiveTime(null)
  }

  const handleBooking = () => {
    const confirm = window.confirm(`Are you sure you want to book an appointment for ${convertClassicDate(activeDate, true)}, at ${activeTime}?`)
    if (!confirm) return
    alert('Your appointment has been booked successfully! You will receive a confirmation email shortly.')
    setActiveTime(null)
    setName('')
    setEmail('')
    monthsEvents.find((month) => month.monthNumber === activeDate?.getMonth() + 1)
      .events.find((event) => event.date.getTime() === activeDate?.getTime())
      .availabilities.find((availability) => availability.time === activeTime).booked = true
  }

  useEffect(() => {
    setActiveDate(new Date(new Date().setHours(0, 0, 0, 0)))
  }, [])

  return (
    <div className="appointment-page">
      <HelmetTitle title="Make An Appointment" />
      <PageBanner
        title="Make An Appointment"
        subtitle="Schedule your appointment with us today!"
      />
      <div className="page-content">
        <SiteGrid>
          <div className="info-section">
            <h5>Choose a time slot to schedule your appointment with one of our doctors.</h5>
            <h6>All appointments last 1 hour maximum</h6>
          </div>
          <div className="schedule-grid">
            <div className="calendar-container">
              <AppCalendar
                events={monthsEvents}
                viewMode="dayGridMonth"
                setViewMode={() => { }}
                calendarRef={calendarRef}
                initialView="dayGridMonth"
                setCalendarRangeStartDate={setCalendarRangeStartDate}
                setCalendarRangeEndDate={setCalendarRangeEndDate}
                customCalendarViewTitle={customCalendarViewTitle}
                setCustomCalendarViewTitle={setCustomCalendarViewTitle}
                handleDateClick={handleDateClick}
                dayCellClassNames={customDayClassNames}
                todayBtn={
                  <AppButton
                    label="Today"
                    buttonType="outlineBtn animate"
                    onClick={() => goToToday()}
                  />
                }
              />
            </div>
            <div className="slots-container">
              <div className="top">
                <h4>{convertClassicDate(activeDate, true)}</h4>
                <div className="slots">
                  <h5>Select Time</h5>
                  {
                    hasAvailabilities ?
                      slotsRender :
                      <small>No availabilities for this date</small>
                  }
                </div>
                {
                  activeDate && activeTime &&
                  <div className="confirm-section">
                    <span className="booking-message">You may now schedule your appointment by entering your name and email below.</span>
                    <h5>Appointment Details</h5>
                    <small><span>Time:</span> {convertClassicDate(activeDate, true)}, at {activeTime}</small>
                    <small><span>Doctor:</span> {doctor?.name}</small>
                  </div>
                }
              </div>
              <div className="booking-section">
                <div className="left">
                  <AppInput
                    placeholder="Enter your name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                  <AppInput
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <div className="right">
                  <AppButton
                    label="Book Appointment"
                    onClick={handleBooking}
                    buttonType="outlineBtn animate"
                    disabled={!allowBooking}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="contact-section">
            <h5>Have questions? Contact us!</h5>
            <p>If you cannot find a time slot that works for you, please contact us and we will do our best to accommodate you.</p>
            <AppButton
              label="Contact Us"
              url="/contact"
            />
          </div>
        </SiteGrid>
      </div>
    </div>
  )
}

export const TimeSlot = ({ time, isBooked, isActive, onClick }) => {

  return (
    <div
      className={`time-slot ${isBooked ? 'booked' : ''} ${isActive ? 'active' : ''}`}
      onClick={() => !isBooked && onClick(time)}
    >
      <h6>{time}</h6>
    </div>
  )
}